import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DateTimeService } from '../../services/date-time.service';

@Component({
	selector: 'app-parcel-items',
	templateUrl: './parcel-items.component.html',
	styleUrls: ['./parcel-items.component.scss']
})

export class ParcelItemsComponent implements OnInit {
	public dataSource = new MatTableDataSource<any>();
	public dateTimeFormat: any;
	public displayedColumns: string[] = ['parcelItem', 'quantity', 'barcode', 'scannedWhen', 'comments', 'refrigerationType'];
	public page = 1;
	@ViewChild(MatPaginator) public paginator: MatPaginator;
	public itemFilter = 'showAll';
	@Input() public assignments: any[] = [];
	@Input() public stopType: string;
	public assignmentIdNamePairs: any[] = [];

	constructor(private _dateTimeService: DateTimeService) {
	}

	calcTotalItems() {
		let total = 0;
		this.dataSource.data.forEach((item) => {
			total += item.quantity;
		});
		return total;
	}

	filterItems(value) {
		this.itemFilter = value;
		if (value == 'showAll') {
			this.dataSource.data = this.getAllItems();
		} else if (this.stopType == 'ONDEMAND') {
			this.dataSource.data = this.assignments.find(a => a.type.toLowerCase() == value.toLowerCase())?.items;
		} else if (this.stopType == 'ROUTESTOP') {
			this.dataSource.data = this.assignments.find(a => a.id == value)?.items;
		}
	}

	getAllItems() {
		return this.assignments.map(x => x.items).flat(1);
	}

	ngAfterViewInit(): void {
		this.dataSource.paginator = this.paginator;
	}

	ngOnChanges(changes: SimpleChanges) {
		this.filterItems(this.itemFilter);
	}

	ngOnInit(): void {
		this.dateTimeFormat = this._dateTimeService.getDateTime();
		this.assignmentIdNamePairs = this.assignments.map(x => ({ id: x.id, name: x.address?.name }));
		this.assignmentIdNamePairs.sort(x => x.name);
	}
}
